import { FanModel } from './../../../cancel-participation/shared/models/cancel-participation.model';

export class FanProfileModel {
    newDevices: string;
    existingDevices: string; // Active, Enrolled not active, In Progress
    security: number; // ProfileModel profileId
    passcode: boolean;
    notifications: String;
    enrollment: String;
    applications: Array<String>;
    fanList: Array<FanModel>;
    profileName: string;
    emmProductCode: string;
    mdmServiceName: string;
}
